import { usePurchaseContractsDispatch } from './purchase-contracts-context';
import PortalAppService from '../../../application/platform/portal-app-service';
import { IListPurchaseContractsRequest } from '../../../model/base/request/list-purchase-contracts-request';

export function usePurchaseContractsController() {
  const dispatch = usePurchaseContractsDispatch();

  const loadData = async (params: IListPurchaseContractsRequest) => {
    dispatch({ type: 'LOAD_START' });

    try {
      const response = await PortalAppService.requestPurchaseContracts(params);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar contratos';
      dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
    }
  };

  return {
    loadData,
  };
}
